var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Category'
      }],
      "title": "All Category"
    }
  }), _c('div', {
    staticClass: "bg-white w-full rounded-lg my-3 px-0 py-0"
  }, [_c('div', {
    staticClass: "flex justify-between py-3 px-4"
  }, [_c('div', {
    staticClass: "flex-col relative"
  }, [_c('svg', {
    staticClass: "w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2",
      "d": "m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchInput,
      expression: "searchInput"
    }],
    staticClass: "px-11 py-2.5 border rounded-lg text-sm w-96 h-10",
    attrs: {
      "type": "text",
      "placeholder": "Search Category Name..."
    },
    domProps: {
      "value": _vm.searchInput
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value;
      }, _vm.debounceSearch]
    }
  }), _vm.searchInput ? _c('button', {
    staticClass: "absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 hover:text-gray-700",
    attrs: {
      "title": "Clear search"
    },
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm._v(" ✕ ")]) : _vm._e()]), _c('div', {
    staticClass: "flex justify-end"
  }, [_c('button', {
    staticClass: "bg-blue-700 px-3 rounded-lg mr-4 h-10"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        path: '/category/add'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New ")])], 1), _c('t-dropdown', {
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function (_ref) {
        var mousedownHandler = _ref.mousedownHandler,
          focusHandler = _ref.focusHandler,
          blurHandler = _ref.blurHandler,
          keydownHandler = _ref.keydownHandler;
        return _c('div', {
          staticClass: "flex"
        }, [_c('button', {
          staticClass: "flex items-center relative justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg",
          on: {
            "mousedown": mousedownHandler,
            "focus": focusHandler,
            "blur": blurHandler,
            "keydown": keydownHandler
          }
        }, [_c('svg', {
          staticClass: "w-4 h-4 mr-1 text-gray-600 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z"
          }
        })]), _vm._v(" Filter "), _c('svg', {
          staticClass: "w-5 h-5 ml-1 text-gray-600 fill-current",
          attrs: {
            "viewBox": "0 0 20 20",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('polygon', {
          attrs: {
            "points": "9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8"
          }
        })]), _vm.dataBadge ? _c('div', {
          staticClass: "rounded-full w-5 h-5 bg-red-600 absolute -top-2 -right-2 text-white text-xs flex justify-center items-center"
        }, [_vm._v(" " + _vm._s(_vm.dataBadge) + " ")]) : _vm._e()])]);
      }
    }, {
      key: "default",
      fn: function (_ref2) {
        var hide = _ref2.hide,
          blurHandler = _ref2.blurHandler;
        return _c('div', {
          staticClass: "w-custom bg-white absolute -right-2 py-4 border rounded-lg"
        }, [_c('div', {
          staticClass: "flex justify-between mb-3 mt-2 px-4"
        }, [_c('div', [_vm._v("Filter")]), _c('div', {
          on: {
            "click": hide
          }
        }, [_c('svg', {
          staticClass: "w-4 h-4 text-gray-800 dark:text-white cursor-pointer",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "none",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "stroke": "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            "d": "M6 18 17.94 6M18 18 6.06 6"
          }
        })])])]), _c('div', {
          staticClass: "block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100",
          attrs: {
            "role": "menuitem"
          }
        }, [_c('label', {
          staticClass: "text-gray-600 font-semibold mb-3"
        }, [_vm._v("Status")]), _c('StatusFilterComponent', {
          attrs: {
            "options": _vm.statusOptions,
            "defaultText": "Select Status"
          },
          model: {
            value: _vm.status,
            callback: function ($$v) {
              _vm.status = $$v;
            },
            expression: "status"
          }
        }), _c('div', {
          staticClass: "mt-3"
        }, [_c('button', {
          staticClass: "border bg-blue-700 px-4 py-2 text-white rounded-lg",
          on: {
            "click": _vm.onStatusChange,
            "blur": blurHandler
          }
        }, [_vm._v(" Filter ")]), _c('button', {
          staticClass: "border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2",
          on: {
            "click": function ($event) {
              return _vm.onReset();
            },
            "blur": blurHandler
          }
        }, [_vm._v("Reset")])])], 1)]);
      }
    }])
  })], 1)]), _c('div', {
    staticClass: "bg-white w-full mt-0 mb-3 rounded-lg pt-0 pb-2 shadow-none overflow-hidden"
  }, [_c('div', {
    ref: "scrollContainer",
    staticClass: "relative"
  }, [_c('Table', {
    attrs: {
      "headers": _vm.headers,
      "data": this.items,
      "row-key": ['name', 'slug', 'category_bisac', 'category_ax', 'is_active', 'created', 'modified'],
      "current-page": _vm.currentPage,
      "isLoading": _vm.isLoading,
      "per-page": _vm.perPage
    },
    scopedSlots: _vm._u([{
      key: "header-created-date",
      fn: function (_ref3) {
        var column = _ref3.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "header-modified-date",
      fn: function (_ref4) {
        var column = _ref4.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "created",
      fn: function (_ref5) {
        var value = _ref5.value;
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(value).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDate(value).time))])];
      }
    }, {
      key: "category_bisac",
      fn: function (_ref6) {
        var _row$category_bisac$n, _row$category_bisac;
        var row = _ref6.row;
        return [_c('span', [_vm._v(_vm._s((_row$category_bisac$n = (_row$category_bisac = row.category_bisac) === null || _row$category_bisac === void 0 ? void 0 : _row$category_bisac.name) !== null && _row$category_bisac$n !== void 0 ? _row$category_bisac$n : '-'))])];
      }
    }, {
      key: "category_ax",
      fn: function (_ref7) {
        var _row$category_ax$ax$c, _row$category_ax;
        var row = _ref7.row;
        return [_c('span', [_vm._v(_vm._s((_row$category_ax$ax$c = (_row$category_ax = row.category_ax) === null || _row$category_ax === void 0 ? void 0 : _row$category_ax.ax.code) !== null && _row$category_ax$ax$c !== void 0 ? _row$category_ax$ax$c : '-'))])];
      }
    }, {
      key: "modified",
      fn: function (_ref8) {
        var value = _ref8.value;
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(value).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDate(value).time))])];
      }
    }, {
      key: "is_active",
      fn: function (_ref9) {
        var value = _ref9.value;
        return [_c('div', {
          staticClass: "text-center py-1 px-1.5 rounded-lg w-auto",
          class: {
            'bg-green-100': value === true,
            'bg-gray-100': value === false
          }
        }, [value ? _c('span', [_vm._v(" Active ")]) : _c('span', [_vm._v(" Inactive ")])])];
      }
    }, {
      key: "actions",
      fn: function (_ref10) {
        var row = _ref10.row;
        return [_c('router-link', {
          staticClass: "link text-gray-600 align-middle items-center flex justify-center",
          attrs: {
            "to": {
              path: '/category/edit/' + row.id
            }
          }
        }, [_c('svg', {
          staticClass: "w-6 h-6 text-gray-600 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z",
            "clip-rule": "evenodd"
          }
        }), _c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z",
            "clip-rule": "evenodd"
          }
        })])])];
      }
    }])
  })], 1), !_vm.isLoading && this.items.length ? _c('div', {
    staticClass: "flex bg-white justify-between px-4 pl-0 pr-3 pt-4 mb-0 border-t border-gray-100 mt-1"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.onClickPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }